import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const GoogleAnalytics = ({ cookieState }) => {
  const location = useLocation();
  const isInitialized = useRef(false); // Verhindert doppelte Initialisierung

  useEffect(() => {
    if (cookieState) {
      if (!window.gtag && !isInitialized.current) {
        const script = document.createElement("script");
        script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GA_ID}`;
        script.async = true;
        document.head.appendChild(script);

        script.onload = () => {
          window.dataLayer = window.dataLayer || [];
          function gtag() {
            window.dataLayer.push(arguments);
          }
          window.gtag = gtag;

          gtag("consent", "update", {
            analytics_storage: "granted",
          });

          gtag("js", new Date());
          gtag("config", process.env.REACT_APP_GA_ID, {
            page_path: location.pathname,
          });

          isInitialized.current = true;
        };
      } else if (window.gtag) {
        window.gtag("config", process.env.REACT_APP_GA_ID, {
          page_path: location.pathname,
        });
      }
    }
  }, [location, cookieState]);

  return null;
};

export default GoogleAnalytics;
